/* eslint-disable react/no-did-mount-set-state */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import { mainText } from 'aegisv2/styles/colors';
import { withApollo } from 'react-apollo';
import compose from 'lodash/flowRight';
import { connect } from 'react-redux';
import { formatProduct } from 'Jsx/Utils/buyProduct';
import T from 'aegisv2/Text';
import ArrowLeft from 'crehana-icons/ArrowLeft';
import CustomSelect from 'Shared/CustomSelect';
// import ContentWrapper from 'Catalog/ui/ContentWrapper';
import STRINGS from 'Catalog/strings';

import CourseRecommended from 'Jsx/Catalog/components/CourseRecommended';
import { primaryMain } from 'crehana-ui/styles/colors';
import {
  COURSES_SEARCH_PAGE_SEARCH,
  // formatCourseV2,
  checkIfisInShoppingCart,
} from 'Catalog/utils';

import getCoursesBySearch from 'Jsx/Catalog/graphql/searchCourses.graphql';
import coursesHighlightedQuery from 'Jsx/Catalog/graphql/coursesHighlighted.graphql';
import transformData from 'Jsx/Utils/transformData';
// import CourseList from '../../containers/CourseList';
import CourseList from './SearchCourseList';

import {
  getCurrentPage,
  getTotalPages,
  setCurrentPage,
  setTotalPages,
} from '../../Pagination/ducks';

// Custom Card for Highlighted courses
import { HighlightedCard } from './SearchCards';

// import CustomSwiper from '../LandingV2/components/CustomSwiper';
import Pagination from '../../Pagination';

import {
  PaginationWrapper,
  ContentTopWrapper,
  ScrollTopWrapper,
  ScrollTopIconWrapper,
  EmptySubTitle,
  ResultsTitle,
  SelectWrapper,
  SelectLabel,
  FadeIn,
  SubCategoryTag,
  SubCategoryTagContainer,
  SlidesWrapper,
  Slides,
  Slide,
  HideScrollBarElement,
  Mobile,
  Desktop,
  HighlightedWrapper,
  SearchCardWrapper,
  SearchContainer,
  Container,
} from './styles';

const getCursor = (currentPage, pageSize) => {
  // in SSR return the page 0 in base64 (arrayconnection:0)
  if (typeof window === 'undefined') return 'YXJyYXljb25uZWN0aW9uOjA=';
  return btoa(`arrayconnection:${(currentPage - 1) * pageSize - 1}`);
};

const CustomSelectStyled = styled(CustomSelect)`
  & > div > div:first-child {
    line-height: 0;
    min-height: 24px;
    & > div {
      line-height: 24px;
    }
  }
`;

const DEFAULT_CURSOR = 'YXJyYXljb25uZWN0aW9uOi0x';

class SearchLanding extends Component {
  state = {
    orderBy: {
      value: this.props.orderBy[0],
      items: this.props.orderBy,
      placeholder: null,
    },
    levels: {
      value: { label: 'Todos los niveles', value: '' },
      items: [{ label: 'Todos los niveles', value: '' }, ...this.props.levels],
      placeholder: null,
    },
    subCategoriesSelected: this.props.subCategoriesSelected,
    isMounted: false,
    isMobile: false,

    // apollo - graphql
    loading: true,
    loadingHighlighted: true,
    courses: null,
    coursesHighlighted: null,
    totalCount: 0,
    totalPages: 0,
  };

  componentDidMount() {
    const isMobile = window.innerWidth <= 680;
    const { orderBy, levels } = this.props;
    const state = {
      isMobile,
      // isMounted: true,
    };

    if (isMobile) {
      this.setState(
        {
          orderBy: {
            value: null,
            items: orderBy,
            placeholder: 'Ordenar por',
          },
          levels: {
            value: null,
            items: levels,
            placeholder: 'Niveles',
          },
          ...state,
        },
        this.mountComponent,
      );
    } else {
      this.mountComponent();
    }
    this.fetchHighlightedCourses();
    this.fetchCourses();
  }

  componentDidUpdate(prevProps) {
    if (this.props.currentPage !== prevProps.currentPage) {
      this.fetchCourses({
        cursor: getCursor(this.props.currentPage, COURSES_SEARCH_PAGE_SEARCH),
        search:
          this.state.subCategoriesSelected.length > 0 ? '' : this.props.search,
      });
    }
  }

  mountComponent = () => {
    this.setState({ isMounted: true });
  };

  clearFilters = () => {
    const { orderBy, levels } = this.state;

    if (
      orderBy.value.value === this.props.orderBy[0].value &&
      levels.value.value === ''
    ) {
      window.location.href = '/cursos-online/';
    } else {
      this.setState(
        {
          orderBy: {
            value: this.props.orderBy[0],
            items: this.props.orderBy,
            placeholder: null,
          },
          levels: {
            value: { label: 'Todos los niveles', value: '' },
            items: [
              { label: 'Todos los niveles', value: '' },
              ...this.props.levels,
            ],
            placeholder: null,
          },
        },
        this.fetchCourses,
        this.fetchHighlightedCourses,
      );
    }
  };

  fetchCourses = (variables = {}) => {
    const {
      // loading,
      orderBy,
      levels,
      subCategoriesSelected,
    } = this.state;
    const {
      client: { query },
      search,
      // courseIdsOwned,
    } = this.props;

    this.setState({ loading: true, errors: false }, () => {
      query({
        query: getCoursesBySearch,
        fetchPolicy: 'cache-first',
        variables: {
          pageSize: COURSES_SEARCH_PAGE_SEARCH,
          newOrderBy: orderBy.value ? orderBy.value.value : '',
          level: levels.value ? levels.value.value : '',
          search,
          cursor: DEFAULT_CURSOR,
          newSubCategories: subCategoriesSelected.join(','),
          ...variables,
        },
      })
        .then(({ data: { searchCourses } }) => {
          this.setState({
            loading: false,
            errors: false,
            totalCount: searchCourses.totalCount,
            totalPages: Math.ceil(
              searchCourses.totalCount / COURSES_SEARCH_PAGE_SEARCH,
            ),
            courses: transformData(searchCourses),
          });
        })
        .catch(errors => {
          console.warn({ errors });
          this.setState({ loading: false, errors: true, courses: null });
        });
    });
  };

  fetchHighlightedCourses = (variables = {}) => {
    const { orderBy, levels, subCategoriesSelected } = this.state;
    const {
      client: { query },
      search,
    } = this.props;

    this.setState({ loadingHighlighted: true, error: false }, () => {
      query({
        query: coursesHighlightedQuery,
        fetchPolicy: 'cache-first',
        variables: {
          search,
          pageSize: 2,
          newOrderBy: orderBy.value ? orderBy.value.value : '',
          level: levels.value ? levels.value.value : '',
          newSubCategories: subCategoriesSelected.join(','),
          ...variables,
        },
      })
        .then(({ data: { coursesHighlighted } }) => {
          this.setState({
            loadingHighlighted: false,
            errorHighlighted: false,
            coursesHighlighted: transformData(coursesHighlighted),
          });
        })
        .catch(errors => {
          console.warn({ errors });
          this.setState({
            loadingHighlighted: false,
            errorHighlighted: true,
            coursesHighlighted: null,
          });
        });
    });
  };

  onChange = key => value => {
    const { currentPage, setCurrentPage: setCurrentPageAction } = this.props;

    this.setState(
      ({ [key]: current }) => ({
        [key]: {
          ...current,
          value,
        },
      }),
      () => {
        if (currentPage === 1) {
          const { levels, orderBy } = this.state;

          this.fetchCourses({
            newOrderBy: orderBy.value ? orderBy.value.value : '',
            level: levels.value ? levels.value.value : '',
          });
        } else {
          setCurrentPageAction(1);
        }
      },
    );
  };

  selectSubCategory = subCategory => () => {
    const { currentPage, setCurrentPage: setCurrentPageAction } = this.props;
    const { subCategoriesSelected } = this.state;
    const { name } = subCategory;
    let newSubCategoriesSelected = [];

    if (subCategoriesSelected.includes(subCategory.name)) {
      newSubCategoriesSelected = subCategoriesSelected.filter(
        sc => sc !== subCategory.name,
      );
    } else {
      newSubCategoriesSelected = [...subCategoriesSelected, name];
    }

    this.setState(
      {
        subCategoriesSelected: newSubCategoriesSelected,
      },
      () => {
        if (currentPage === 1) {
          this.fetchCourses({
            search: '',
          });
          this.fetchHighlightedCourses({
            search: '',
          });
        } else {
          setCurrentPageAction(1);
        }
      },
    );
  };

  renderHighlighted = () => {
    const {
      loadingHighlighted,
      coursesHighlighted,
      errorHighlighted,
    } = this.state;
    const {
      removeCourseFromCart,
      addCourseToCart,
      user,
      courseIdsOwned,
    } = this.props;
    const courses = loadingHighlighted
      ? []
      : coursesHighlighted.map(checkIfisInShoppingCart(courseIdsOwned));

    if (errorHighlighted) return null;

    return loadingHighlighted ? (
      <div />
    ) : coursesHighlighted.length ? (
      <React.Fragment>
        <Container>
          <T size={18} lineHeight={23} bold>
            Destacados de búsqueda
          </T>
        </Container>
        <div style={{ backgroundColor: '#fafafa' }}>
          <HighlightedWrapper>
            {courses.map(c => (
              <SearchCardWrapper key={c.originalId}>
                <HighlightedCard
                  {...c}
                  removeCourseFromCart={removeCourseFromCart}
                  addCourseToCart={addCourseToCart}
                  onImageHover
                  itemTypeTrack="HIGHLIGHTEDCOURSE"
                  user={user}
                  product={formatProduct(c, 'course')}
                />
              </SearchCardWrapper>
            ))}
          </HighlightedWrapper>
        </div>
      </React.Fragment>
    ) : null;
  };

  renderSubCategoriesTags = () => {
    const { subCategoriesSelected, loading } = this.state;
    const { searchObj, categories } = this.props;

    if (!searchObj.category) return null;

    const subCategories = Object.values(categories).find(
      c => c.slug === searchObj.category.slug,
    ).sub_categories;

    const subCategoriesComponents = subCategories.map(sc => {
      const selected = subCategoriesSelected.includes(sc.name);
      const onClick = this.selectSubCategory(sc);

      return (
        <Slide key={sc.slug}>
          <SubCategoryTag
            selected={selected}
            onClick={!loading ? onClick : undefined}
            disabled={loading}
          >
            <T lineHeight={17} xs bold color={selected ? '#fff' : mainText}>
              {sc.name}
            </T>
          </SubCategoryTag>
        </Slide>
      );
    });

    return (
      <div style={{ marginTop: 12 }}>
        <p>
          <T xs lineHeight={17}>
            Subcategorías relacionadas
          </T>
        </p>
        <Mobile>
          <SubCategoryTagContainer style={{ marginTop: 16 }}>
            <SlidesWrapper>
              <Slides>{subCategoriesComponents}</Slides>
              <HideScrollBarElement />
            </SlidesWrapper>
          </SubCategoryTagContainer>
        </Mobile>
        <Desktop>
          <SubCategoryTagContainer style={{ marginTop: 16 }}>
            {subCategoriesComponents}
          </SubCategoryTagContainer>
        </Desktop>
      </div>
    );
  };

  render() {
    const {
      levels,
      orderBy,
      isMounted,
      isMobile,
      // apollo graphql
      loading,
      totalPages,
      courses,
      totalCount,
    } = this.state;
    const {
      courseIdsOwned,
      theme,
      removeCourseFromCart,
      scrollTop,
      search,
      addCourseToCart,
      user,
      isOrganization,
      loadingCartButton,
      userLanguage,
    } = this.props;

    const selectWidth = isMobile ? '138px' : '190px';
    const itemsPerRow = {
      1680: 4,
      1440: 4,
      1280: 4,
      1024: 3,
      768: 2,
    };
    const selectPadding = isMobile ? '5px' : '10px 15px';
    const selectComponents = isMounted ? (
      <SelectWrapper>
        <FadeIn visible={isMounted}>
          <SelectLabel xs>Nivel</SelectLabel>
          <CustomSelectStyled
            onChange={this.onChange('levels')}
            value={levels.value}
            options={levels.items}
            placeholder={levels.placeholder}
            menuStyles={{
              width: selectWidth,
              backgroundColor: '#fff',
              border: '1px solid #DFE1E6',
              fontWeight: 'bold',
            }}
            controlStyles={{
              width: selectWidth,
              border: '1px solid #DFE1E6',
              color: '#09f',
              padding: selectPadding,
              fontWeight: 'bold',
            }}
            optionStyles={{
              padding: selectPadding,
            }}
            classNamePrefix="filterSelect"
            instanceId="catalog-search-select-levels"
            selectWrapped
            renderArrow
            isDisabled={loading || (!loading && !courses.length)}
          />
        </FadeIn>
        <FadeIn visible={isMounted}>
          <SelectLabel xs>Ordernar por</SelectLabel>
          <CustomSelectStyled
            onChange={this.onChange('orderBy')}
            value={orderBy.value}
            options={orderBy.items}
            placeholder={orderBy.placeholder}
            menuStyles={{
              width: selectWidth,
              backgroundColor: '#fff',
              border: '1px solid #DFE1E6',
              fontWeight: 'bold',
            }}
            controlStyles={{
              width: selectWidth,
              border: '1px solid #DFE1E6',
              color: '#09f',
              padding: selectPadding,
              fontWeight: 'bold',
            }}
            optionStyles={{
              padding: selectPadding,
            }}
            classNamePrefix="filterSelect"
            instanceId="catalog-search-select-orderBy"
            selectWrapped
            renderArrow
            isDisabled={loading || (!loading && !courses.length)}
          />
        </FadeIn>
      </SelectWrapper>
    ) : null;

    if (!loading && (!courses || !courses.length)) {
      // const orderByText = orderBy.value ? `cursos ${orderBy.value.value}` : '';
      // const levelsText = (levels.value && levels.value.value) ? `, nivel ${levels.value.name}` : '';
      const emptyTitle = `No hemos encontrado resultados para "${search}"`;

      return (
        <SearchContainer>
          <ResultsTitle>
            <h1
              className="text-16 font-bold md:text-24"
              style={{ lineHeight: '24px' }}
            >
              {emptyTitle}
            </h1>
          </ResultsTitle>
          <EmptySubTitle>{STRINGS.results.emptySubTitle}</EmptySubTitle>
          {/* {selectComponents} */}
          <a
            // onClick={this.clearFilters}
            href="/cursos-online/"
            style={{ outline: 'none', width: 'fit-content' }}
          >
            <T color={primaryMain}>
              <ArrowLeft color={primaryMain} size={10} /> Regresar
            </T>
          </a>
          <div style={{ height: 32, width: '100%' }} />
          <CourseRecommended
            courseIdsOwned={courseIdsOwned}
            removeCourseFromCart={removeCourseFromCart}
            addCourseToCart={addCourseToCart}
            itemsPerRow={itemsPerRow}
            isOrganization={isOrganization}
            loadingCartButton={loadingCartButton}
          />
        </SearchContainer>
      );
    }

    const title = `Resultados de búsqueda para "${search}"`;

    return (
      <React.Fragment>
        <SearchContainer>
          <ContentTopWrapper a="flex-start" J="space-between" d="row">
            <ResultsTitle d="column">
              <h1
                className="text-16 font-bold md:text-24"
                style={{ lineHeight: '24px' }}
              >
                {title}
              </h1>
            </ResultsTitle>
            {this.renderSubCategoriesTags()}
            {selectComponents}
          </ContentTopWrapper>
        </SearchContainer>
        {this.renderHighlighted()}
        <SearchContainer>
          <CourseList
            userLanguage={userLanguage}
            skeletonItems={24}
            courseIdsOwned={courseIdsOwned}
            courses={
              loading
                ? []
                : courses.map(checkIfisInShoppingCart(courseIdsOwned))
            }
            loading={loading}
            removeCourseFromCart={removeCourseFromCart}
            addCourseToCart={addCourseToCart}
            isUserLogged={!!user}
            user={user}
            itemsPerRow={itemsPerRow}
            isOrganization={isOrganization}
            loadingCartButton={loadingCartButton}
          />
          {(isMobile ? totalCount > 10 : totalCount > 25) && (
            <PaginationWrapper>
              <ScrollTopWrapper a="center" onClick={scrollTop}>
                <ScrollTopIconWrapper>
                  <ArrowLeft color={primaryMain} size={7} />
                </ScrollTopIconWrapper>
                <T bold color={primaryMain}>
                  {STRINGS.backToTop}
                </T>
              </ScrollTopWrapper>
              <Pagination loading={loading} totalPages={totalPages} />
            </PaginationWrapper>
          )}
        </SearchContainer>
      </React.Fragment>
    );
  }
}

SearchLanding.propTypes = {
  courseIdsOwned: PropTypes.arrayOf(PropTypes.number).isRequired,
  currentPage: PropTypes.number,
  removeCourseFromCart: PropTypes.func.isRequired,
  addCourseToCart: PropTypes.func.isRequired,
  scrollTop: PropTypes.func.isRequired,
  search: PropTypes.string,
  // toggleFilterCategory: PropTypes.func.isRequired,
  theme: PropTypes.shape({}).isRequired,
  user: PropTypes.shape({}),
  orderBy: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  ).isRequired,
  levels: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  ).isRequired,
  searchObj: PropTypes.shape({
    value: PropTypes.string.isRequired,
    sub_category: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      slug: PropTypes.string,
    }),
    category: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      slug: PropTypes.string,
    }),
  }).isRequired,
  setCurrentPage: PropTypes.func.isRequired,
  categories: PropTypes.shape({}).isRequired,
  client: PropTypes.shape({
    query: PropTypes.func.isRequired,
  }).isRequired,
  subCategoriesSelected: PropTypes.arrayOf(PropTypes.string).isRequired,
  isOrganization: PropTypes.bool,
  loadingCartButton: PropTypes.bool.isRequired,
  userLanguage: PropTypes.string.isRequired,
};

SearchLanding.defaultProps = {
  courses: undefined,
  currentPage: 1,
  loading: false,
  orderBy: '',
  pages: 1,
  search: null,
  softwares: null,
  levels: null,
  totalPages: 1,
  user: null,
  categorySelected: null,
  totalCount: null,
  isOrganization: false,
};

const mapStateToProps = state => {
  const { search, userLanguage } = state;
  const orderBy = state.orderBy.items
    .filter(o => o.slug !== 'ofertas')
    .map(o => ({ label: o.name, value: o.slug }));
  let levels = state.filters.levels.subItems;

  levels = Object.keys(levels).map(key => ({
    label: levels[key].name,
    value: levels[key].slug,
  }));

  return {
    orderBy,
    levels,
    userLanguage,
    currentPage: getCurrentPage(state),
    pages: getTotalPages(state),
    searchObj: search,
    categories: state.filters.categories,
    subCategoriesSelected: search.sub_category
      ? [search.sub_category.name]
      : [],
  };
};

export default compose(
  connect(
    mapStateToProps,
    {
      setCurrentPage,
      setTotalPages,
    },
  ),
  withApollo,
  withTheme,
)(SearchLanding);
